import {
  CashBankTransactionListParams,
  CashBankTransactionsResultEntity,
} from "../entities";
import { CashAndBankRepository } from "../repositories";

export class GetCashBankTransactionsUseCase {
  constructor(private repository: CashAndBankRepository) {}

  async execute(
    params: CashBankTransactionListParams,
  ): Promise<CashBankTransactionsResultEntity> {
    if (!params.accountId) {
      throw new Error("Account ID is required");
    }

    if (params.limit !== undefined && (params.limit < 1 || params.limit > 100)) {
      throw new Error("Limit must be between 1 and 100");
    }

    return this.repository.fetchTransactions(params);
  }
}
